const articles = require('../content/articles.json');

const ALLOWED_SLUGS = new Set(articles.map((entry) => entry.slug));
const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/**
 * @param {string} slug
 */
function assertSafeSlug(slug) {
  if (!slug || typeof slug !== 'string') {
    throw new Error('Missing article slug');
  }
  if (!SLUG_PATTERN.test(slug) || !ALLOWED_SLUGS.has(slug)) {
    throw new Error('Invalid article slug');
  }
}

/**
 * Webpack emits bundled markdown as same-origin asset URLs. Reject anything else
 * before fetch to mitigate SSRF when loading dynamic content modules.
 *
 * @param {string} url
 */
function assertSafeAssetUrl(url) {
  if (typeof url !== 'string' || !url) {
    throw new Error('Invalid markdown asset URL');
  }

  if (url.startsWith('/')) {
    return;
  }

  const parsed = new URL(url, window.location.origin);
  if (parsed.origin !== window.location.origin) {
    throw new Error('Untrusted markdown asset URL');
  }
}

/**
 * Load a bundled markdown file for a known article slug.
 *
 * @param {string} slug - Article slug from the articles catalog.
 * @returns {Promise<string>} Raw markdown text.
 */
async function loadBundledMarkdown(slug) {
  assertSafeSlug(slug);

  const module = await import(`../content/${slug}.md`);
  const assetUrl = module.default;
  assertSafeAssetUrl(assetUrl);

  const response = await fetch(assetUrl, { redirect: 'error' });
  if (!response.ok) {
    throw new Error('Failed to load markdown content');
  }

  return response.text();
}

module.exports = {
  loadBundledMarkdown,
  assertSafeSlug,
  assertSafeAssetUrl,
};
